<script setup lang="ts">
import { useTitle, breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import VideoPresentation from "../../assets/video/landing.webm";
import TranslateNamespace from "addeus-common-library/components/base/translation/TranslateNamespace.vue";
import ImageCustomer from "../../assets/image/home/img_customer.jpg";
import ImageBusiness from "../../assets/image/home/img_business.jpg";
import ImageBackground from "../../assets/image/home/img_bg.jpg";
import ImagePaques from "../../assets/image/hours_easter.png";

import IconBar from "../../assets/image/home/icon_bar.svg";
import IconCup from "../../assets/image/home/icon_cup.svg";
import IconKart from "../../assets/image/home/icon_kart.svg";
import IconParty from "../../assets/image/home/icon_party.svg";
import IconStructure from "../../assets/image/home/icon_structure.svg";
import IconDown from "../../assets/image/home/icon_down.svg";
import IconTrack from "../../assets/image/home/icon_track.svg";
import { useOwner } from "../../stores/website/owner";
import { useMomentaryModal } from "../../stores/website/momentaryModal";
import moment from "moment-timezone";
import { onMounted } from "vue";

const breakpoints = useBreakpoints(breakpointsTailwind);
const ownerManager = useOwner();
const momentaryModal = useMomentaryModal();

const isSmallerThanS = breakpoints.smallerOrEqual("sm");
const isSmallerThanM = breakpoints.smallerOrEqual("md");
const isSmallerThanXl = breakpoints.smallerOrEqual("xl");
const isSmallerThan2Xl = breakpoints.smallerOrEqual("2xl");

useTitle("Speed2Max");

function navigate(router: any, path: string) {
    void router.push(path);
}

function navigateBooking(router: any) {
    if (ownerManager.owner !== undefined && ownerManager.owner !== null) {
        const toPush = ownerManager.owner.bookableOnline
            ? "/booking"
            : {
                  name: "owners-:owner",
                  params: {
                      owner: ownerManager.owner?.$getID(),
                  },
              };
        void router.push(toPush);
    } else {
        void router.push("/owners");
    }
}

function maxHeighValue() {
    if (isSmallerThanS.value) {
        return 30;
    } else if (isSmallerThanM.value) {
        return 33;
    } else if (isSmallerThanXl.value) {
        return 36;
    } else if (isSmallerThan2Xl.value) {
        return 40;
    } else {
        return 100;
    }
}
function arrowTopPosition() {
    if (isSmallerThanM.value) {
        return -6;
    } else if (isSmallerThanXl.value) {
        return -8;
    } else if (isSmallerThan2Xl.value) {
        return -10;
    } else {
        return -12;
    }
}

onMounted(() => {
    const date = moment().set({ date: 5, month: 4, year: 2025, hour: 4 }).startOf("hour");
    // void momentaryModal.showImageModal(ImagePaques, "vTXLhu8lijTkVTWosH8t", date);
    void momentaryModal.showImageModal(ImagePaques, "vcBdNdzePyv0Bd9YKIFZ", date);
});
/* eslint-disable-next-line */
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','externalDataLayer','GTM-W4RM97KW');
</script>

<template>
    <VFlex
        flex-direction="column"
        align-items="stretch"
        class="has-background-dark has-text-white">
        <div>
            <div :class="{ 'video-landing': !isSmallerThanXl }" style="display: flex">
                <video
                    playsinline
                    loop
                    muted
                    autoplay
                    crossorigin="anonymous"
                    :class="{ 'mb-4': isSmallerThanXl }">
                    <source :src="VideoPresentation" />
                </video>
            </div>
            <div
                v-if="!isSmallerThanXl"
                style="
                    position: relative;
                    text-align: center;
                    right: 0;
                    left: 0;
                    z-index: 10;
                    height: 0;
                "
                :style="{
                    top: arrowTopPosition() + 'em',
                }">
                <a href="#informations">
                    <img
                        :src="IconDown"
                        alt="Move down"
                        class="animated"
                        style="width: 56px" />
                </a>
            </div>
        </div>
        <TranslateNamespace path=".home">
            <ImageHeader
                id="informations"
                :style="{
                    'max-height': maxHeighValue() + 'vh',
                }">
                <template #image>
                    <img src="/images/kart/faireDuKart/bg-faire-du-kart.jpg" alt="Kart" />
                </template>
                <template #title>
                    <div><Translate path=".titleP1"></Translate>&nbsp;</div>
                    <div class="has-text-primary mt-2">
                        <Translate path=".titleP2"></Translate>
                    </div>
                </template>
                <template #subtitle>
                    <Translate path=".subtitle"></Translate>
                </template>
                <template #icon>
                    <img :src="IconTrack" alt="Kart" />
                </template>
            </ImageHeader>
            <!-- Bloc customers -->
            <div
                class="is-flex mx-auto mb-3 my-6 w-80"
                :class="{ 'is-flex-direction-column': isSmallerThanXl }">
                <div
                    class="mt-auto mb-6 is-size-6"
                    :class="{ 'w-half': !isSmallerThanXl }">
                    <TranslateNamespace path=".b2c">
                        <div
                            class="is-size-4 is-weight-700 is-uppercase"
                            style="line-height: 1.2em">
                            <div>
                                <Translate path=".titleP1"></Translate>
                            </div>
                            <div
                                class="is-size-2 has-text-primary is-font-mohol"
                                :class="{
                                    'is-size-4': isSmallerThanXl,
                                }">
                                <Translate path=".titleP2"></Translate>
                            </div>
                        </div>
                        <div style="height: 1.5em"></div>
                        <div class="mb-2 is-weight-600">
                            <Translate path=".content1"></Translate>
                        </div>
                        <div class="mb-2"><Translate path=".content2"></Translate></div>
                        <div class="mb-2"><Translate path=".content3"></Translate></div>
                        <div style="height: 1.5em"></div>
                        <div
                            class="is-flex is-justify-content-flex-start is-flex-wrap-wrap">
                            <button
                                class="button btn-size is-weight-bold is-size-6 is-success has-background-primary mb-3 is-font-mohol is-uppercase"
                                @click="navigateBooking($router)">
                                <div class="m-auto">
                                    <Translate path=".btnBook"></Translate>
                                </div>
                            </button>
                            <button
                                class="button btn-size is-weight-700 is-size-6 is-primary is-outlined mb-3 is-uppercase"
                                :class="{ 'ml-5': !isSmallerThan2Xl }"
                                @click="navigate($router, '/kart')">
                                <div class="m-auto">
                                    <Translate path=".btnMore"></Translate>
                                </div>
                            </button>
                        </div>
                    </TranslateNamespace>
                </div>
                <div
                    class="my-auto mx-3 has-text-centered"
                    :class="{ 'w-half': !isSmallerThanXl }">
                    <img :src="ImageCustomer" alt="" />
                </div>
            </div>
            <!-- Bloc Business -->
            <div
                class="is-flex is-flex-direction-row-reverse mx-auto my-6 w-80"
                :class="{ 'is-flex-direction-column': isSmallerThanXl }">
                <div
                    class="mt-auto mb-6 is-size-6 has-text-right"
                    :class="{ 'w-half': !isSmallerThanXl }">
                    <TranslateNamespace path=".b2b">
                        <div
                            class="is-size-4 is-weight-700 is-uppercase"
                            style="line-height: 1.2em">
                            <div>
                                <Translate path=".titleP1"></Translate>
                            </div>
                            <div
                                class="is-size-2 has-text-primary is-font-mohol"
                                :class="{
                                    'is-size-4': isSmallerThanXl,
                                }">
                                <Translate path=".titleP2"></Translate>
                            </div>
                        </div>
                        <div style="height: 1.5em"></div>
                        <div class="mb-2 is-weight-600">
                            <Translate path=".content1"></Translate>
                        </div>
                        <div class="mb-2"><Translate path=".content2"></Translate></div>
                        <div style="height: 1.5em"></div>
                        <div
                            class="is-flex is-justify-content-flex-end is-flex-wrap-wrap">
                            <button
                                class="button btn-size is-weight-700 is-size-6 is-primary is-outlined mb-3 is-uppercase"
                                :class="{ 'mr-5': !isSmallerThan2Xl }"
                                @click="navigate($router, '/event-your/enterprise')">
                                <div class="m-auto">
                                    <Translate path=".btnBook"></Translate>
                                </div>
                            </button>
                            <button
                                class="button btn-size is-weight-700 is-size-6 is-primary is-outlined mb-3 is-uppercase"
                                @click="navigate($router, '/event-us')">
                                <div class="m-auto">
                                    <Translate path=".btnMore"></Translate>
                                </div>
                            </button>
                        </div>
                    </TranslateNamespace>
                </div>

                <div
                    class="my-auto mx-3 has-text-centered is-flex-grow-2"
                    :class="{ 'w-half': !isSmallerThanXl }">
                    <img :src="ImageBusiness" alt="" />
                </div>
            </div>
            <!-- Bloc Cards -->
            <div
                class="w-70 mx-auto mb-5 is-size-6 is-flex is-flex-wrap-wrap is-flex-direction-row is-justify-content-space-evenly">
                <div class="has-background-white p-2 mx-2 my-3 card">
                    <img :src="IconStructure" alt="Structure" />
                    <p class="has-text-dark-navy has-text-weight-bold px-4">
                        <Translate>.structure</Translate>
                    </p>
                </div>
                <div class="has-background-white p-2 mx-2 my-3 card">
                    <img :src="IconCup" alt="Challenges" />
                    <p class="has-text-dark-navy has-text-weight-bold px-4">
                        <Translate>.challenges</Translate>
                    </p>
                </div>
                <div class="has-background-white p-2 mx-2 my-3 card">
                    <img :src="IconKart" alt="Accessibility" />
                    <p class="has-text-dark-navy has-text-weight-bold px-4">
                        <Translate>.access</Translate>
                    </p>
                </div>
                <div class="has-background-white p-2 mx-2 my-3 card">
                    <img :src="IconBar" alt="Snack" />
                    <p class="has-text-dark-navy has-text-weight-bold px-4">
                        <Translate>.snack</Translate>
                    </p>
                </div>
                <div class="has-background-white p-2 mx-2 my-3 card">
                    <img :src="IconParty" alt="Party" />
                    <p class="has-text-dark-navy has-text-weight-bold px-4">
                        <Translate>.party</Translate>
                    </p>
                </div>
            </div>
            <!-- Bloc description -->
            <div
                class="is-flex is-flex-direction-column is-size-5 has-bg-kart-img py-6"
                :class="{ 'is-size-6': isSmallerThanXl }">
                <TranslateNamespace path=".description">
                    <div
                        class="is-size-4 is-weight-700 is-uppercase mt-5 mb-1"
                        style="line-height: 1em">
                        <div class="has-text-centered">
                            <Translate path=".titleP1"></Translate>
                        </div>
                        <div
                            class="has-text-centered has-text-primary is-font-mohol is-size-1 mb-5 mt-1"
                            :class="{ 'is-size-2': isSmallerThanXl }"
                            style="line-height: 1em">
                            <translate path=".titleP2"></translate>
                        </div>
                    </div>

                    <div class="mb-2 has-text-centered w-80 mx-auto mb-1 mt-4">
                        <Translate path=".content1"></Translate>
                    </div>
                    <div class="mb-2 has-text-centered w-80 mx-auto mb-4 mt-1">
                        <Translate path=".content2"></Translate>
                    </div>
                </TranslateNamespace>
                <div
                    class="is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-evenly w-80 mx-auto my-6">
                    <button
                        class="button is-primary is-outlined is-size-5 py-0 m-2 btn-size is-font-mohol is-uppercase"
                        @click="navigate($router, '/discover/history')">
                        <div class="m-auto">
                            <Translate>.enterprise</Translate>
                        </div>
                    </button>
                    <button
                        class="button is-primary is-outlined is-size-5 py-0 m-2 btn-size is-font-mohol is-uppercase"
                        @click="navigate($router, '/discover/licence')">
                        <div class="m-auto">
                            <Translate>.licence</Translate>
                        </div>
                    </button>
                    <button
                        class="button is-primary is-outlined is-size-5 py-0 m-2 btn-size is-font-mohol is-uppercase"
                        @click="navigate($router, '/product-technology/karting')">
                        <div class="m-auto">
                            <Translate>.technology</Translate>
                        </div>
                    </button>
                </div>
            </div>
        </TranslateNamespace>
        <Footer></Footer>
        <!-- Google Tag Manager (noscript) -->
        <!-- eslint-disable-next-line -->
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W4RM97KW" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <!-- End Google Tag Manager (noscript) -->
    </VFlex>
</template>

<style lang="scss" scoped>
*::after {
    box-sizing: border-box;
    display: inline-block;
}

.video-landing {
    width: 100%;
    min-height: 100vh;
    object-fit: cover;
    pointer-events: none;
}

.has-bg-kart-img {
    background-image: v-bind("`url('${ImageBackground}')`");
    background-size: cover;
    background-position: center;
}

.has-no-background {
    background-color: transparent;
}

.has-border-primary {
    border: 2px solid $primary;
}

.button {
    &.btn-size {
        width: 14em;
        height: 3em;
        text-wrap: wrap;
    }
}

.is-font-sofia {
    font-family: Sofia-Pro;
}

.has-text-dark-navy {
    color: #091f2b;
}

.is-font-mohol {
    font-family: Mohol;
}

.card {
    display: flex;
    flex-basis: min-content;
    width: 30%;
    min-width: 280px;
    align-items: center;

    > img {
        width: 60px;
    }

    > p {
        display: inline;
        text-wrap: wrap;
        max-width: 65%;
    }
}

.h-4em {
    height: 4em;
}

.w-20p {
    width: 20%;
    min-width: 250px;
}

.w-half {
    width: 50%;
}

.w-90 {
    width: 90%;
}

.w-80 {
    width: 80%;
}

.w-70 {
    width: 70%;
}

.w-60 {
    width: 60%;
}

.w-40 {
    width: 40%;
}

.w-30 {
    width: 3cm;
}

.w-20 {
    width: 20%;
}

.title-p2 {
    display: inline;
    position: relative;
    z-index: 1;

    &.sub-line {
        &::after {
            content: "";
            position: relative;
            z-index: -1;
            bottom: 0.7em;
            left: -5%;
            width: 100%;
            height: 0.7em;
            background-color: $primary;
        }

        &.sub-line-mobile {
            &::after {
                width: 100%;
            }
        }

        &.sub-line-right {
            &::after {
                right: -5%;
                left: unset;
            }
        }
    }
}

.title-p2-right {
    display: inline;
    position: relative;
    z-index: 1;

    &::after {
        content: "";
        position: relative;
        z-index: -1;
        bottom: 0.7em;
        right: -5%;
        width: 70%;
        height: 0.7em;
        background-color: $primary;
    }
}
</style>
